import { produce } from 'immer';
import { omit, set } from 'lodash';

import { UpdateInternalBannerTemplateResources } from '../../../actions/bannersEdit/internal/updateInternalBannerTemplateResources';
import { selectEditedInternalBannerTemplateResources } from '../../../selectors/internalBannerEdit/internalBannerEdit';
import { EditInternalBannersState } from '../../../typings/internalBannersEditState';

export function updateInternalBannerTemplateResources(
    state: EditInternalBannersState,
    action: UpdateInternalBannerTemplateResources
): EditInternalBannersState {
    return produce(state, draft => {
        const { bannerId, resourceId, value } = action;
        const banner = draft.banners[bannerId];

        banner.templateVars.some(templateVar => {
            const found = resourceId === templateVar.resourceId;

            if (found) {
                templateVar.value = value;
            }

            return found;
        });

        const resources = selectEditedInternalBannerTemplateResources(draft, bannerId);

        if (resources) {
            resources.some((resource, index) => {
                const found = resource.id === resourceId;

                if (found) {
                    set(banner, 'errors', omit(banner.errors, [`templateVars.${index}`]));
                }

                return found;
            });
        }
    });
}
